import { render, staticRenderFns } from "./ReputDetail.vue?vue&type=template&id=392d71b0&scoped=true&"
import script from "./ReputDetail.vue?vue&type=script&lang=js&"
export * from "./ReputDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReputDetail.vue?vue&type=style&index=0&id=392d71b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392d71b0",
  null
  
)

export default component.exports